import React from "react";
import { Layout, styles } from "../../../layout"; // adjust path a
// ims needed
import Figure from "../../components/figure";
import carboncalc from "./carboncalc.png"; // adjust path as needed

const CarbonCalcUpdate: React.FC = () => {
  return (
    <Layout title="Carbon Calculator Project">
      <p style={styles.paragraph}>
        This was a very early version of my carbon calculator. I was learning
        how to take more data inputs from my website and store them in a Google
        Sheet.
      </p>

      <p style={styles.paragraph}>
        I actually got it to work But the code was a mess.
      </p>

      <p style={styles.paragraph}>
        Still, I learned a lot through the process:
      </p>

      <ul style={styles.list}>
        <li style={styles.listItem}>
          <span style={styles.bulletIcon}>•</span>
          How to take user inputs and push them to Google Sheets
        </li>
        <li style={styles.listItem}>
          <span style={styles.bulletIcon}>•</span>
          How to structure data from forms into clean spreadsheet rows
        </li>
        <li style={styles.listItem}>
          <span style={styles.bulletIcon}>•</span>
          How to display data and charts on a web page using React
        </li>
      </ul>

      <p style={styles.paragraph}>
        This version was clunky and just a practice project. I wanted to
        recreate our carbon calc on my own site!
      </p>

      <Figure
        imageSrc={carboncalc}
        altText="Carbon Calc Code Jack Pearson"
        caption="I had over 1000 lines of code for this simple project. And it was all one page..."
        size="medium"
        title="Too much code on one page"
      />
    </Layout>
  );
};

export default CarbonCalcUpdate;
